export default "__VITE_ASSET__DwLQzMXa__"